"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4925],{

/***/ 14925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(7397);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11719);
/* harmony import */ var _components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62412);
/* harmony import */ var _components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53056);
/* harmony import */ var _utility_cr_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46236);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34853);
/* harmony import */ var _components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97344);
/* harmony import */ var _material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44080);
/* harmony import */ var _utility_tools_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92061);
/* harmony import */ var _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66306);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5969);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31955);
/* harmony import */ var _components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98950);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89147);
/* harmony import */ var _components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98910);
/* harmony import */ var _constants_CountryAndLanguages__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23661);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(19337);
/* harmony import */ var _utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4465);






















var useStyles = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(theme) {
    return {};
});
var AiTextWriter = function(param) {
    var classes = param.classes, setShowSignUpPage = param.setShowSignUpPage, user = param.user, handleResetUsage = param.handleResetUsage, hasValidSubscription = param.hasValidSubscription, enableLockedOption = param.enableLockedOption, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard, _isCreditsShown = param.isCreditsShown, isCreditsShown = _isCreditsShown === void 0 ? false : _isCreditsShown, _creditsRemaining = param.creditsRemaining, creditsRemaining = _creditsRemaining === void 0 ? 0 : _creditsRemaining, _usagePerDay = param.usagePerDay, usagePerDay = _usagePerDay === void 0 ? 0 : _usagePerDay, setShowBuyOnePass = param.setShowBuyOnePass, setIsRedirectToWebflow = param.setIsRedirectToWebflow, _setShowMinimumCreditsNeededMsg = param.setShowMinimumCreditsNeededMsg, setShowMinimumCreditsNeededMsg = _setShowMinimumCreditsNeededMsg === void 0 ? function(a) {} : _setShowMinimumCreditsNeededMsg, setShowVerifyEmailPopup = param.setShowVerifyEmailPopup, _freeToolsUsage = param.freeToolsUsage, freeToolsUsage = _freeToolsUsage === void 0 ? 0 : _freeToolsUsage, _showFreeToolsUsage = param.showFreeToolsUsage, showFreeToolsUsage = _showFreeToolsUsage === void 0 ? false : _showFreeToolsUsage, _isCorpEmail = param.isCorpEmail, isCorpEmail = _isCorpEmail === void 0 ? false : _isCorpEmail;
    var ref;
    var ownClasses = useStyles();
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), topic = ref1[0], setTopic = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Formal"), tone = ref2[0], setTone = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("English"), outputLanguage = ref3[0], setOutputLanguage = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("5"), numSentences = ref4[0], setNumSentences = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), instructions = ref5[0], setInstructions = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), error = ref7[0], setError = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), result = ref8[0], setResult = ref8[1];
    var isMobile = (0,_utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_16__/* .useView */ .Pl)("mobileOnly");
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copied = ref9[0], setCopied = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), recaptchaValue = ref10[0], setRecaptchaValue = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), captchaError = ref11[0], setCaptchaError = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), creditsNeeded = ref12[0], setCreditsNeeded = ref12[1];
    var inputSelectionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__/* .useSession */ .kP)();
    var handleRecaptchaChange = function(value) {
        setRecaptchaValue(value);
        setCaptchaError("");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
            isAnonymousUser: !user,
            payload: {
                label: "Visited Free Tool",
                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                isQwaDashboard: isQwaDashboard
            }
        });
    }, []);
    var handleGenerateParagraph = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var isContinueWriting, res, axiosError, _args = arguments;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isContinueWriting = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        _ctx.prev = 1;
                        setLoading(true);
                        if (topic) {
                            _ctx.next = 6;
                            break;
                        }
                        setError("topic");
                        return _ctx.abrupt("return");
                    case 6:
                        if (recaptchaValue || qttr_tools_auth || user) {
                            _ctx.next = 9;
                            break;
                        }
                        setCaptchaError("recaptchaValue");
                        return _ctx.abrupt("return");
                    case 9:
                        setCaptchaError("");
                        setError("");
                        _ctx.next = 13;
                        return (0,_utility_cr_common__WEBPACK_IMPORTED_MODULE_5__/* .fetchAIBasedContent */ .LK)({
                            promptFor: "PUBLIC_UTILITY.AI_TEXT_GENERATOR",
                            promptConfig: {
                                topic: topic,
                                noOf: numSentences,
                                specialInstructions: instructions,
                                tone: tone,
                                language: outputLanguage,
                                prevText: isContinueWriting ? result : "",
                                isContinueWriting: isContinueWriting
                            },
                            tokenLimit: 10000,
                            isPublicApi: true,
                            reCAPTCHAToken: recaptchaValue
                        });
                    case 13:
                        res = _ctx.sent;
                        if (res) {
                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                eventFor: "button",
                                buttonText: "",
                                counterName: "".concat(_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools, " Outputs"),
                                isAddCount: true,
                                isAnonymousUser: !user,
                                user: user,
                                payload: {
                                    label: "Generate Output",
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                    special_instructions_yn: instructions ? "Yes" : "No",
                                    isQwaDashboard: isQwaDashboard,
                                    creditsConsumed: isContinueWriting ? 1 : creditsNeeded ? creditsNeeded : 1,
                                    isContinueWriting: isContinueWriting,
                                    language: outputLanguage || "English",
                                    tone: tone,
                                    noOfSentences: numSentences
                                }
                            });
                            if (handleResetUsage) {
                                handleResetUsage();
                            }
                        }
                        setResult(isContinueWriting ? "".concat(result, " ").concat(res) : res);
                        _ctx.next = 23;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](1);
                        axiosError = _ctx.t0;
                        if (axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) {
                            if (axiosError.response.status === 403) {
                                setShowSignUpPage(_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_7__/* .CONTINUE_USING_TEXT */ .gt, {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Reached your maximum usage limit",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                        console.error("handleGenerateSummary:: ", _ctx.t0);
                    case 23:
                        _ctx.prev = 23;
                        setRecaptchaValue(null);
                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .resetCaptcha */ .Ler)();
                        setLoading(false);
                        return _ctx.finish(23);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18,
                    23,
                    28
                ]
            ]);
        }));
        return function handleGenerateParagraph() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCopyText = function() {
        var inputElement = inputSelectionRef === null || inputSelectionRef === void 0 ? void 0 : inputSelectionRef.current;
        if (inputElement) {
            var ref;
            var copiedText = inputElement === null || inputElement === void 0 ? void 0 : (ref = inputElement.value) === null || ref === void 0 ? void 0 : ref.substring((inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionStart) || 0, (inputElement === null || inputElement === void 0 ? void 0 : inputElement.selectionEnd) || 0);
            if (copiedText) {
                navigator.clipboard.writeText(copiedText);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                        special_instructions_yn: instructions ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard,
                        isManualCopy: true
                    }
                });
            } else {
                navigator.clipboard.writeText(result);
                setCopied(true);
                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                    eventFor: "button",
                    buttonText: "",
                    counterName: "Outputs Accepted",
                    isAddCount: true,
                    user: user,
                    isAnonymousUser: !user,
                    payload: {
                        label: "Copy Generated Output",
                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                        special_instructions_yn: instructions ? "Yes" : "No",
                        isQwaDashboard: isQwaDashboard
                    }
                });
            }
        }
        setTimeout(function() {
            setCopied(false);
        }, 2000); // Change the text back to 'Copy Text' after 2 seconds
    };
    var numbers = [
        "1",
        "3",
        "5",
        "10",
        "15",
        "20",
        "25"
    ];
    var NumberOptions = numbers.map(function(number) {
        // Keep the first item as a number
        if ([
            "1",
            "3",
            "5"
        ].includes(number)) {
            return number;
        }
        // Convert the rest to objects, include a React component for the icon
        return {
            name: number,
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_8__/* .PremiumToolsIcon */ .WL, {})
        };
    });
    var changeToneOptions = [
        "Formal",
        "Casual",
        "Neutral",
        "Factual",
        {
            name: "Authoritative",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_utility_tools_config__WEBPACK_IMPORTED_MODULE_8__/* .PremiumToolsIcon */ .WL, {})
        },
        {
            name: "Conversational",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                    fill: "#FFC72C"
                })
            })
        },
        {
            name: "Persuasive",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                    fill: "#FFC72C"
                })
            })
        },
        {
            name: "Business Formal",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                    fill: "#FFC72C"
                })
            })
        },
        {
            name: "Creative / Descriptive",
            requireLogin: !hasValidSubscription && !enableLockedOption,
            icon: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Lock__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                className: classes.unlockIcon
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                    fill: "#FFC72C"
                })
            })
        }, 
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var promptFor = _utility_common__WEBPACK_IMPORTED_MODULE_10__/* .PAID_TOOLS_PROMPT_FOR.AI_TEXT_GENERATOR */ .rMq.AI_TEXT_GENERATOR;
        var promptConfig = {
            topic: topic,
            noOf: numSentences,
            specialInstructions: instructions,
            tone: tone,
            language: outputLanguage
        };
        setCreditsNeeded((0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .getToolsUsageCreditsNeeded */ .Nmb)(promptFor, promptConfig));
    }, [
        user,
        topic,
        tone,
        numSentences,
        instructions,
        outputLanguage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: classes.container,
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_4__/* .QuattrLogoSpinner */ .h, {
                classes: classes
            }),
            result ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        inputRef: inputSelectionRef,
                        fullWidth: true,
                        multiline: true,
                        rows: (0,_components_ToolsStyleWrapper__WEBPACK_IMPORTED_MODULE_7__/* .calculateRows */ .Gm)(result),
                        margin: "normal",
                        placeholder: "Generated Text",
                        value: result,
                        className: "".concat(classes.textAreaInput, " no-border background-gray"),
                        maxRows: 200,
                        InputProps: {
                            style: {
                                borderRadius: "4px !important",
                                padding: "20px 16px"
                            }
                        },
                        minRows: 20,
                        variant: "outlined",
                        onCopy: handleCopyText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "dflex j-flex-end ".concat(classes.outputActionBtnWrapper),
                        style: {
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA),
                                disabled: loading,
                                style: {
                                    float: "right",
                                    marginRight: "16px"
                                },
                                onClick: function() {
                                    setResult("");
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "Clicked on Go back",
                                        payload: {
                                            label: "Clicked on Go back"
                                        }
                                    });
                                },
                                children: "Go back"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                className: classes.toolsYellowCTA,
                                disabled: loading,
                                style: {
                                    float: "right",
                                    marginRight: "16px"
                                },
                                onClick: handleCopyText,
                                children: copied ? "Copied!" : "Copy Text"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                className: classes.toolsYellowCTA,
                                disabled: loading,
                                style: {
                                    float: "right",
                                    background: !hasValidSubscription && !enableLockedOption ? "lightgray" : "#FFC72C"
                                },
                                onClick: function() {
                                    if (setShowSignUpPage && !hasValidSubscription && !enableLockedOption) {
                                        setShowSignUpPage("'Continue Writing'", {
                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                        });
                                        (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                            eventFor: "button",
                                            isAnonymousUser: !user,
                                            payload: {
                                                label: "Clicked Locked Option",
                                                component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                                screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                                option_name: "Continue Writing",
                                                isQwaDashboard: isQwaDashboard
                                            }
                                        });
                                    } else {
                                        (0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleGenerateParagraph, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage, true);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center"
                                        },
                                        children: [
                                            "Continue Writing",
                                            isCreditsShown || !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                style: {
                                                    fontSize: "12px"
                                                },
                                                children: "(Uses 1 Credit)"
                                            }) : ""
                                        ]
                                    }),
                                    !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            "\xa0 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                className: classes.lockIcon
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: "Enter Topic",
                        value: topic,
                        variant: "outlined",
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important"
                            }
                        },
                        onChange: function(e) {
                            return setTopic(e.target.value);
                        },
                        className: "".concat(classes.textAreaInput, " no-border mb-15"),
                        error: !!error,
                        helperText: error.includes("topic") ? "* Required" : error.includes("Please sign up") ? error : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mb-15",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: "Number of Sentences",
                            value: numSentences,
                            options: NumberOptions,
                            onChange: function(e) {
                                var value = e.target.value;
                                var option = NumberOptions.find(function(o) {
                                    return (typeof o === "string" ? o : o.name) === value;
                                });
                                if (option && (typeof option === "string" || !option.requireLogin)) {
                                    setNumSentences(e.target.value);
                                } else {
                                    setShowSignUpPage("'Generate ".concat(value, " sentences'"), {
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                    });
                                    (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                        eventFor: "button",
                                        isAnonymousUser: !user,
                                        payload: {
                                            label: "Clicked Locked Option",
                                            component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                            screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                            tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                            tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                            option_name: "Generate ".concat(value, " sentences"),
                                            isQwaDashboard: isQwaDashboard
                                        }
                                    });
                                }
                            },
                            classes: classes
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Change Tone",
                                    value: tone,
                                    options: changeToneOptions,
                                    onChange: function(e) {
                                        var value = e.target.value;
                                        var option = changeToneOptions.find(function(o) {
                                            return (typeof o === "string" ? o : o.name) === value;
                                        });
                                        if (option && (typeof option === "string" || !option.requireLogin)) {
                                            setTone(value);
                                        } else {
                                            setShowSignUpPage("'Rewrite with ".concat(value, " tone'"), {
                                                tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                                tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                            });
                                            (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                                eventFor: "button",
                                                isAnonymousUser: !user,
                                                payload: {
                                                    label: "Clicked Locked Option",
                                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                                    option_name: "Rewrite with ".concat(value, " tone"),
                                                    isQwaDashboard: isQwaDashboard
                                                }
                                            });
                                        }
                                    },
                                    classes: classes
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CustomerDropDownWithLock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    label: "Language",
                                    value: outputLanguage,
                                    options: (ref = _constants_CountryAndLanguages__WEBPACK_IMPORTED_MODULE_15__/* .LANGUAGES.map */ .a2.map(function(language) {
                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                        return (ref5 = (ref3 = (ref1 = language === null || language === void 0 ? void 0 : (ref = language.name) === null || ref === void 0 ? void 0 : ref.split(";")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.split(",")) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.split("(")) === null || ref5 === void 0 ? void 0 : ref5[0];
                                    })) === null || ref === void 0 ? void 0 : ref.sort(),
                                    onChange: function(e) {
                                        setOutputLanguage(e.target.value);
                                    },
                                    classes: classes
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        fullWidth: true,
                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                className: "m-0 ".concat(classes.additionInstructionsText),
                                children: [
                                    "Additional instructions you would like to include",
                                    " ",
                                    !hasValidSubscription && !enableLockedOption ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        style: {
                                            marginBottom: "-3px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z",
                                            fill: "#FFC72C"
                                        })
                                    })
                                ]
                            })
                        }),
                        value: instructions,
                        onChange: function(e) {
                            return setInstructions(e.target.value);
                        },
                        multiline: true,
                        rows: !hasValidSubscription && !enableLockedOption ? 1 : 4,
                        className: "".concat(classes.textAreaInput, " no-border"),
                        variant: "outlined",
                        inputProps: {
                            readOnly: !hasValidSubscription && !enableLockedOption ? true : false
                        },
                        InputProps: {
                            style: {
                                backgroundColor: "#fff",
                                borderRadius: "4px !important"
                            },
                            endAdornment: !hasValidSubscription && !enableLockedOption ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                position: "end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    className: classes.lockIcon
                                })
                            }) : null
                        },
                        onClick: function() {
                            if (setShowSignUpPage && !hasValidSubscription && !enableLockedOption) {
                                setShowSignUpPage("'Add Additional Instructions'", {
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                });
                                (0,_src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    isAnonymousUser: !user,
                                    payload: {
                                        label: "Clicked Locked Option",
                                        component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                        tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                        tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools,
                                        option_name: "Add Additional Instructions",
                                        isQwaDashboard: isQwaDashboard
                                    }
                                });
                            }
                        }
                    }),
                    !qttr_tools_auth && !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: classes.recaptcha,
                                sitekey: "6LfNnmAqAAAAAFm-6SDC8c9lFenCJX2_QkckWpsd",
                                onChange: handleRecaptchaChange
                            }),
                            (captchaError === null || captchaError === void 0 ? void 0 : captchaError.includes("recaptchaValue")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                className: "red",
                                children: "Please complete the reCAPTCHA to verify you're human."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SkipCaptcha__WEBPACK_IMPORTED_MODULE_12__/* .SkipCaptcha */ .h, {
                                classes: classes,
                                meta: {
                                    component_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                    screen_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools,
                                    tool_name: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_NAME.ai_text_generator */ .vG.ai_text_generator,
                                    tool_category: _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .CONTENT_AI_TOOL_CATEGORY.ai_content_writing_tools */ ._V.ai_content_writing_tools
                                },
                                setShowVerifyEmailPopup: setShowVerifyEmailPopup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "".concat(isCreditsShown ? classes.creditsShown : classes.freeCreditsShown),
                        children: [
                            isCreditsShown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: creditsRemaining,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: usagePerDay
                            }) : !isQwaDashboard || showFreeToolsUsage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CreditsInfo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                classes: classes,
                                creditsRemaining: freeToolsUsage,
                                creditsNeeded: creditsNeeded,
                                usagePerDay: isCorpEmail ? 10 : 7,
                                showFreeToolsUsage: showFreeToolsUsage
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "d-flex ".concat(classes.buttonGroup),
                                style: {
                                    marginTop: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        style: {
                                            float: "right"
                                        },
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.toolsOutlinedCTA, " ").concat(classes.button),
                                        onClick: function() {
                                            setNumSentences("5");
                                            setInstructions("");
                                        },
                                        children: "Clear"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        className: "".concat(classes.toolsYellowCTA, " ").concat(classes.button),
                                        color: "primary",
                                        onClick: function() {
                                            return (0,_utility_common__WEBPACK_IMPORTED_MODULE_10__/* .handleGenerateOutput */ .jx$)(creditsRemaining, creditsNeeded, isQwaDashboard, session, qttr_tools_daypass_auth, setShowMinimumCreditsNeededMsg, setShowBuyOnePass, handleGenerateParagraph, _src_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_9__/* .trackAnalyticsEvent */ .ec, freeToolsUsage, showFreeToolsUsage);
                                        },
                                        children: "Generate Text"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AiTextWriter);


/***/ })

}]);